<template>
  <PolarArea
    :options="computedChartOptions"
    :data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :width="width"
    :height="height"
    data-test-name="polar-area-chart"
    data-test-variant=""
    data-test-state=""
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { PolarArea } from 'vue-chartjs'
import * as ChartJS from 'chart.js'
import { cloneDeep, merge } from 'lodash-unified'
import { getChartDefaultOptions } from './utils'
import type { PropType } from 'vue'
import type { ChartData, ChartOptions, Plugin } from 'chart.js'

const { ArcElement, Chart, Legend, RadialLinearScale, Title, Tooltip } = ChartJS
Chart.register(Title, Tooltip, Legend, ArcElement, RadialLinearScale)

defineOptions({ name: 'BPolarAreaChart' })

const props = defineProps({
  chartId: {
    type: String,
    default: 'polar-area-chart',
  },
  datasetIdKey: {
    type: String,
    default: 'label',
  },
  width: {
    type: Number,
    default: 240,
  },
  height: {
    type: Number,
    default: 240,
  },
  plugins: {
    type: Array as PropType<Plugin<'polarArea'>[]>,
    default: () => [],
  },
  chartData: {
    type: Object as PropType<ChartData<'polarArea', number[], unknown>>,
    default: () => ({ datasets: [] }),
  },
  chartOptions: {
    type: Object as PropType<ChartOptions<'polarArea'>>,
    default: () => ({ responsive: true, maintainAspectRatio: true }),
  },
})

const defaultOptions = cloneDeep(
  getChartDefaultOptions('polar')
) as ChartOptions<'polarArea'>

const computedChartOptions = computed(() =>
  merge(defaultOptions, props.chartOptions)
)
</script>
